import React from "react";
import NextLink from "next/link";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useTranslation } from "next-i18next";

import CloudinaryImage from "../../Common/CloudinaryImage";
import Illustration from "../../../public/static/images/our-expertise/illustration.png";

const Hero = () => {
  const { t } = useTranslation("our-expertise");

  return (
    <Box>
      <Box marginTop={5} marginBottom={4}>
        <Typography
          sx={{
            textTransform: "uppercase",
            fontWeight: "medium",
          }}
          gutterBottom
          color={"textSecondary"}
          align={"center"}
        >
          {t("hero.title")}
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant={"h3"}
          gutterBottom
          align={"center"}
        >
          {t("hero.subtitle")}
        </Box>
        <Typography
          variant={"h6"}
          component={"p"}
          color={"textSecondary"}
          align={"center"}
        >
          {t("hero.content")}
        </Typography>
        <Box marginTop={3} display={"flex"} justifyContent={"center"}>
          <NextLink href="/demo" passHref>
            <Box
              component={Button}
              variant="contained"
              color="primary"
              size="large"
              endIcon={
                <svg
                  width={16}
                  height={16}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                  />
                </svg>
              }
            >
              {t("hero.cta")}
            </Box>
          </NextLink>
        </Box>
      </Box>
      <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
        <Box height={"100%"} width={"100%"} maxWidth={600}>
          <CloudinaryImage
            src={Illustration}
            alt={`${t("hero.title")} illustration`}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Hero;
